import React from 'react';
import CountryRestriction from './Restriction/country_restriction';

const Restriction = () => <CountryRestriction />;

export default Restriction;
